import React, { useReducer, useState } from "react";
import { ChatAdapterStore } from "../../contexts/ChatAdapterStore";
import { ChatContextStore } from "../../contexts/ChatContextStore";
import { ChatSDKStore } from "../../contexts/ChatSDKStore";
import { FacadeChatSDK } from "../../common/facades/FacadeChatSDK";
import { FacadeChatSDKStore } from "../../contexts/FacadeChatSDKStore";
import LiveChatWidgetStateful from "./livechatwidgetstateful/LiveChatWidgetStateful";
import { createReducer } from "../../contexts/createReducer";
import { getLiveChatWidgetContextInitialState } from "../../contexts/common/LiveChatWidgetContextInitialState";
import { getMockChatSDKIfApplicable } from "./common/getMockChatSDKIfApplicable";
import { isNullOrUndefined } from "../../common/utils";
import overridePropsOnMockIfApplicable from "./common/overridePropsOnMockIfApplicable";
export const LiveChatWidget = props => {
  var _props$mock, _props$featureConfigP, _props$chatConfig, _props$chatConfig$Liv;
  const reducer = createReducer();
  const [state, dispatch] = useReducer(reducer, getLiveChatWidgetContextInitialState(props));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [adapter, setAdapter] = useState(undefined);
  const [facadeChatSDK, setFacadeChatSDK] = useState(undefined);
  const chatSDK = getMockChatSDKIfApplicable(props.chatSDK, props === null || props === void 0 ? void 0 : (_props$mock = props.mock) === null || _props$mock === void 0 ? void 0 : _props$mock.type);
  const disableReauthentication = ((_props$featureConfigP = props.featureConfigProps) === null || _props$featureConfigP === void 0 ? void 0 : _props$featureConfigP.disableReauthentication) === true;
  overridePropsOnMockIfApplicable(props);
  if (!props.chatConfig) {
    throw new Error("chatConfig is required");
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isAuthenticatedChat = !!((_props$chatConfig = props.chatConfig) !== null && _props$chatConfig !== void 0 && (_props$chatConfig$Liv = _props$chatConfig.LiveChatConfigAuthSettings) !== null && _props$chatConfig$Liv !== void 0 && _props$chatConfig$Liv.msdyn_javascriptclientfunction);
  if (!facadeChatSDK) {
    var _props$mock2;
    setFacadeChatSDK(new FacadeChatSDK({
      "chatSDK": chatSDK,
      "chatConfig": props.chatConfig,
      "isAuthenticated": isAuthenticatedChat,
      "getAuthToken": props === null || props === void 0 ? void 0 : props.getAuthToken,
      //when type is not undefined, it means the SDK is mocked
      "isSDKMocked": !isNullOrUndefined(props === null || props === void 0 ? void 0 : (_props$mock2 = props.mock) === null || _props$mock2 === void 0 ? void 0 : _props$mock2.type)
    }, disableReauthentication));
  }
  return /*#__PURE__*/React.createElement(FacadeChatSDKStore.Provider, {
    value: [facadeChatSDK, setFacadeChatSDK]
  }, /*#__PURE__*/React.createElement(ChatSDKStore.Provider, {
    value: chatSDK
  }, /*#__PURE__*/React.createElement(ChatAdapterStore.Provider, {
    value: [adapter, setAdapter]
  }, /*#__PURE__*/React.createElement(ChatContextStore.Provider, {
    value: [state, dispatch]
  }, /*#__PURE__*/React.createElement(LiveChatWidgetStateful, props)))));
};
export default LiveChatWidget;